import { useTranslation } from 'react-i18next';
import { cutString } from '../../../../utils/cutString';
import { LoaderSmall } from '../../../../components/LoaderSmall/LoaderSmall';

import '../../../NarrativePage/Filter/Filter.scss';


export const MessagesTabChooser = ({onChange, options, selected = []}) => {
  const { t } = useTranslation();


  const handleSelect = () => {
    if (options.length !== selected.length) {
      onChange(options.map(item => item.value))
    } else {
      onChange([])
    }
  }

  if(!options) return(<LoaderSmall />)


  return(
    <div className='chooser'>
      <div className='control' onClick={() => handleSelect()}>{options.length === selected.length ? t('Deselect all') : t('Select all')}</div>
      <ul>
        {options.map(item => {
          return(
            <li key={item.value}>
              <input 
                id={`messagesTab_${item.value}`}
                type='checkbox'
                checked={selected.includes(item.value)}
                onChange={() => {
                  if (selected.includes(item.value)) {
                    onChange(selected.filter(v => v !== item.value)) 
                  } else {
                    onChange([...selected, item.value]) 
                  }
                }}
              />
              <label htmlFor={`messsagesTab_${item.value}`}>{cutString(item.label, 30)}</label>
            </li>
          )
        })}
        
      </ul>
    </div>
  )
}
